
// Cart Count Bubble
window.SLIDECART_UPDATED = function(cart) {
  setCartCountBubble(cart.item_count);
};

window.SLIDECART_REMOVED_FROM_CART = function({ id }) {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => setCartCountBubble(cart.item_count))
    .catch((e) => console.error('Cart count update after removal failed:', e));
};

function setCartCountBubble(count) {
  const bubble = document.querySelector('.cart-count-bubble');
  const cartLink = document.getElementById('cart-icon-bubble');

  if (bubble) {
    bubble.textContent = count > 0 ? `(${count})` : '';
    bubble.style.display = count > 0 ? '' : 'none';
  }

  if (cartLink) {
    cartLink.setAttribute(
      'aria-label',
      count === 1 ? 'Cart (1 item)' : `Cart (${count} items)`
    );
  }
}




class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    // Use Slide Cart open instead of native notification UI
    if (typeof window.SLIDECART_OPEN === 'function') {
      window.SLIDECART_OPEN();
    } else {
      // Fallback to default behavior if Slide Cart is not available
      this.notification.classList.add('animate', 'active');
      this.notification.addEventListener('transitionend', () => {
        this.notification.focus();
        trapFocus(this.notification);
      }, { once: true });
      document.body.addEventListener('click', this.onBodyClick);
    }
  }

  close() {
    // Use Slide Cart close instead of native notification UI
    if (typeof window.SLIDECART_CLOSE === 'function') {
      window.SLIDECART_CLOSE();
    } else {
      // Fallback to default behavior if Slide Cart is not available
      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // Update non-UI sections (cart icon bubble, etc.) as before
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (!el) return;

      if (section.id === 'cart-notification-product') {
        el.innerHTML =
          el.innerHTML +
          `<div class="cart-notification-product">${this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          )}</div>`;
      } else {
        el.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();

    // Update Slide Cart with latest cart data, then open it
    if (typeof window.SLIDECART_UPDATE === 'function') {
      window.SLIDECART_UPDATE(() => {
        this.open();
      });
    } else {
      this.open();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);